module.exports = __webpack_public_path__ + "static/media/TraumaGrief.8576250b.svg";